import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import {SharedService} from '../../../../core/services/store/shared-store/shared-storage.service';
import {catchError, map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class WaTemplateService {

    private readonly baseUri: string = environment.controlBaseUrl;

    private templateCache: { [key: string]: WaTemplate } = {};

    localEntity = {
        entityId: '',
        entityType: ''
    };


    constructor(private http: HttpClient, private shardService: SharedService) {
    }

    public get_template(templateId: string): Observable<WaTemplate> {

        this.checkEntity();

        if (this.templateCache[templateId]) {
            return of(this.templateCache[templateId]);
        }

        return this.http.get<WaTemplate>(`${this.baseUri}/wa/CLIENT/${this.shardService.getEntityId()}/templates/${templateId}`).pipe(
            map((waTemplate: WaTemplate) => {
                if (waTemplate.templateContent === null) {
                    return waTemplateError;
                }

                this.templateCache[templateId] = waTemplate;
                return waTemplate;
            }),
            catchError((_) => {
                return of(waTemplateError);
            })
        );
    }

    private checkEntity() {
        if (this.shardService.getEntityType() !== this.localEntity.entityType || this.shardService.getEntityId() !== this.localEntity.entityId) {
            this.templateCache = {};
        }

        this.localEntity.entityId = this.shardService.getEntityId();
        this.localEntity.entityType = this.shardService.getEntityType();

    }

}

const waTemplateError: WaTemplate = {
    templateContent: null,
    name: null,
    numOfParams: null,
    tag: null,
    preApproved: null,
    status: null,
    type: null,
    wabaName: null,
    template: null,
    whatsAppBusinessAccount: null,
    id: '_ERROR_',
};

export interface WaTemplate {
    template: string;
    reason?: any;
    numOfParams: number;
    whatsAppBusinessAccount: string;
    language?: { fullName: string; shortName: string };
    wabaName: string;
    type: string;
    templateStatus?: string;
    default?: boolean;
    createdDate?: string;
    rejectedReason?: any;
    name: string;
    modifiedDate?: string;
    preApproved: boolean;
    templateContent: WaTemplateTemplateContent;
    id: string;
    tag: string;
    status: string;
}

export interface WaTemplateTemplateContent {
    'header'?: WaTemplateTemplateContentHeader;
    'body'?: WaTemplateTemplateContentBody;
    'footer'?: string;
    'buttons'?: WaTemplateTemplateContentButtons;
}

export interface WaTemplateTemplateContentHeader {
    'type'?: string;
    'text'?: {
        'text'?: string,
    };
    'media'?: {
        'type'?: 'image' | 'document' | 'video' | undefined,
    };
}

export interface WaTemplateTemplateContentBody {
    'text': string;
    'example': string;
}

export interface WaTemplateIndex {
    text?: string;
    index?: number;
}

export interface WaTemplateIndexUrl {
    text?: string;
    url?: string;
    index?: number;
}

export interface WaTemplateIndexDial {
    text?: string;
    phoneNumber?: string;
    index?: number;
}

export interface WaTemplateAction {
    dial?: WaTemplateIndexDial[];
    websiteUrl?: WaTemplateIndexUrl[];
    websiteUrls?: WaTemplateIndexUrl[];
}

export interface WaTemplateTemplateContentButtons {
    'action': WaTemplateAction;
    'quickReply'?: WaTemplateIndex[];
    'copyCode'?: WaTemplateIndex;
    'catalog'?: WaTemplateIndex;
    'otp'?: WaTemplateIndex;
}




